import styled from '@emotion/styled';

const CloseButton = styled('button')({
  backgroundColor: 'transparent',
  border: 'none',
  cursor: 'pointer',
});

export default CloseButton;
